import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  name: 'Michael R.',
  text: "Bruce and his team were incredible during my divorce proceedings. They were aggressive when needed but always compassionate with me. I couldn't have asked for better representation.",
  type: 'Family Law Client'
}, {
  name: 'Sarah T.',
  text: 'After my car accident, I was overwhelmed with medical bills and insurance companies. This firm stepped in, handled everything, and secured a settlement that covered all my needs.',
  type: 'Personal Injury Client'
}, {
  name: 'David L.',
  text: "When my business faced a complex contract dispute, Bruce's strategic approach saved us time and money. His courtroom presence is truly commanding.",
  type: 'Business Law Client'
}];
export function Testimonials() {
  return <section className="py-16 md:py-24 bg-[#f8f5f0]" data-id="element-159">
      <div className="max-w-7xl mx-auto px-5 md:px-8" data-id="element-160">
        <div className="text-center mb-12 md:mb-16" data-id="element-161">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="font-serif text-3xl sm:text-4xl md:text-5xl text-[#1a1a1a] font-bold mb-4" data-id="element-162">
            Client Testimonials
          </motion.h2>
          <motion.div initial={{
          opacity: 0,
          width: 0
        }} whileInView={{
          opacity: 1,
          width: '80px'
        }} viewport={{
          once: true
        }} className="h-1 bg-[#c9a35a] mx-auto mb-6" data-id="element-163" />
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8" data-id="element-164">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white p-8 shadow-lg relative" data-id="element-165">
              <div className="text-[#c9a35a] mb-4 flex gap-1" data-id="element-166">
                {[...Array(5)].map((_, i) => <Star key={i} size={20} fill="currentColor" data-id="element-167" />)}
              </div>
              <p className="text-gray-600 italic mb-6 leading-relaxed" data-id="element-168">
                "{testimonial.text}"
              </p>
              <div data-id="element-169">
                <p className="font-serif font-bold text-[#1a1a1a] text-lg" data-id="element-170">
                  {testimonial.name}
                </p>
                <p className="text-sm text-[#7c0a0a] uppercase tracking-wider font-semibold" data-id="element-171">
                  {testimonial.type}
                </p>
              </div>

              {/* Decorative Quote Mark */}
              <div className="absolute top-4 right-6 text-8xl text-gray-100 font-serif leading-none select-none z-0 opacity-50" data-id="element-172">
                "
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}